export const LAST_VISITED_COUNTERPARTIES = "last-visited-counterparties";
export const LAST_SELECTED_SIGNATURES = "last-selected-signatures";
export const PERMISSIONS_STORAGE_KEY = "permissions";
